import React from 'react';

export const SvgExpand = props => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.31 11.998L5.301 7.99a1.045 1.045 0 010-1.454 1.026 1.026 0 011.454 0l4.73 4.74a1.026 1.026 0 010 1.454l-4.73 4.73a1.026 1.026 0 01-1.454 0 1.026 1.026 0 010-1.453l4.01-4.009zm7.214 0L12.515 7.99a1.045 1.045 0 010-1.454 1.026 1.026 0 011.453 0l4.73 4.74a1.026 1.026 0 010 1.454l-4.73 4.73a1.026 1.026 0 11-1.453-1.453l4.01-4.009z"
      fill="currentColor"
    />
  </svg>
);
